import React from 'react';
import { graphql } from 'gatsby';
import YepTemplate from 'templates/yep/yep-page';
import { useTranslation } from 'react-i18next';

const YepPage = props => {
  const [t] = useTranslation();
  return (
    <YepTemplate
      {...props}
      seoTitle={t('page--yep.seoTitle')}
      seoDescription={t('page--yep.seoDescription')}
    />
  )
};
export default YepPage;

export const query = graphql`
  query YepPageEng {
    strapiPages(slug: { eq: "/ungdomar/jag-vill-jobba" }) {
      headerImage {
        childImageSharp {
          fluid(maxHeight: 1024, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
    # allStrapiYeptestimonial {
    #   edges {
    #     node {
    #       id
    #       name
    #       age
    #       category
    #       testimonial
    #       image {
    #         childImageSharp {
    #           fluid(maxHeight: 640, quality: 90) {
    #             ...GatsbyImageSharpFluid_withWebp
    #           }
    #         }
    #       }
    #     }
    #   }
    # }
  }
`;
